import { render, staticRenderFns } from "./ZygoteInteraction.vue?vue&type=template&id=3f5372d4&scoped=true&"
import script from "./ZygoteInteraction.vue?vue&type=script&lang=js&"
export * from "./ZygoteInteraction.vue?vue&type=script&lang=js&"
import style0 from "./ZygoteInteraction.vue?vue&type=style&index=0&id=3f5372d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5372d4",
  null
  
)

export default component.exports